<tt-page class="height-full" *ngIf="!!setting">
    <ng-container *ngIf="!tabletSize.matches; else tabletReports">
        <tt-card class="col-xs-12 sp-0">
            <ng-container *ngTemplateOutlet="buttonFunctions"></ng-container>

            <ng-container *ngIf="selectedBgReportDefinitions === 'REPORT'">
                <tt-input ttRememberId="w_p2reportdefs.filtervalue_reports" ttLabel="filtervalue_reports" ttFocus [(ttModel)]="setting.filtervalue_reports" ttShowClearButton></tt-input>
                <tt-button-goto ttText="p2reportdefs_new" ttGoto="p2reportdef" [ttGotoParms]="{ p2_reportdef_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </ng-container>
        </tt-card>

        <tt-list *ngIf="selectedBgReportDefinitions === 'REPORT'" [ttData]="reports" [ttFilter]="setting.filtervalue_reports"></tt-list>
        <tt-list *ngIf="selectedBgReportDefinitions === 'PRINTER'" [ttData]="printers"></tt-list>
        <tt-grid *ngIf="selectedBgReportDefinitions === 'PRINTERLOCATION' && !!printerLocationGrid" class="col-xs-12 p-5 flex-1" [ttOptions]="printerLocationGrid"></tt-grid>
        <tt-list *ngIf="selectedBgReportDefinitions === 'PRINTCLIENT'" [ttData]="clients"></tt-list>
    </ng-container>

    <ng-template #tabletReports>
        <tt-card class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="buttonFunctions"></ng-container>
        </tt-card>

        <tt-grid *ngIf="selectedBgReportDefinitions === 'REPORT' && !!gridReports" class="col-xs-12 p-5 flex-1" [ttOptions]="gridReports"></tt-grid>
        <tt-grid *ngIf="selectedBgReportDefinitions === 'PRINTER' && !!printersGrid" class="col-xs-12 p-5 flex-1" [ttOptions]="printersGrid"></tt-grid>
        <tt-grid *ngIf="selectedBgReportDefinitions === 'PRINTERLOCATION' && !!printerLocationGrid" class="col-xs-12 p-5 flex-1" [ttOptions]="printerLocationGrid"></tt-grid>
        <tt-list *ngIf="selectedBgReportDefinitions === 'PRINTCLIENT'" class="col-xs-12 col-md-6 p-5" [ttData]="clients"></tt-list>
    </ng-template>
</tt-page>

<ng-template #buttonFunctions>
    <ng-container *ngIf="!!setting">
        <tt-button ttText="p2reportdefs_get_reports" [ttSpin]="updatingChanges" ttTextAlign="center" ttType="primary" ttIcon="fas fa-sync-alt" (ttClick)="updateChanges()"></tt-button>

        <tt-tabs [(ttSelectedId)]="selectedBgReportDefinitions">
            <tt-tab ttId="REPORT" ttLabel="p2_reportdefs_reports"></tt-tab>
            <tt-tab ttId="PRINTER" ttLabel="p2_reportdefs_printers"></tt-tab>
            <tt-tab ttId="PRINTERLOCATION" ttLabel="p2_reportdefs_printerlocation"></tt-tab>
            <tt-tab ttId="PRINTCLIENT" ttLabel="p2_reportdefs_printclient"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>
